import React, { Component } from 'react';
import { Grid, Cell, ProgressBar } from 'react-mdl';

class Skills extends Component {
    render() {
        return (
            <Grid className="skill-row">
                <Cell col={4} tablet={4} phone={12} className="skill-label">
                    <span>{this.props.skill}</span>
                </Cell>
                <Cell col={8} tablet={8} phone={12} className="skill-bar">
                    <ProgressBar className="skill-progress" progress={this.props.progress} />
                </Cell>
            </Grid>
        );
    }
}

export default Skills;
